import { useCallback } from "react";
import { MakeApiCall } from "../apis";

const pad = (value) => String(value).padStart(2, "0");

export const formatToHubSpotDateTime = (date = new Date()) => {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}`;
};

export const useHubSpotSync = (userData) => {
  const syncProperties = useCallback(
    (properties = {}) => {
      const payload =
        properties && typeof properties === "object" && !Array.isArray(properties)
          ? properties
          : {};

      // Fire-and-forget background sync to keep the UI responsive.
      Promise.resolve().then(async () => {
        try {
          await MakeApiCall(
            "hubspot-engagement/sync-properties",
            "post",
            payload,
            true,
            {},
            userData?.token
          );
        } catch (error) {
          console.error("HubSpot engagement sync failed:", error);
        }
      });
    },
    [userData?.token]
  );

  const syncActionTimestamp = useCallback(
    (actionKey, date = new Date()) => {
      if (!actionKey || typeof actionKey !== "string") return;
      syncProperties({ [actionKey]: formatToHubSpotDateTime(date) });
    },
    [syncProperties]
  );

  const syncActionCount = useCallback(
    (actionKey, count = 1) => {
      if (!actionKey || typeof actionKey !== "string") return;
      const parsedCount = Number.isFinite(Number(count)) ? Number(count) : 1;
      syncProperties({ [actionKey]: parsedCount });
    },
    [syncProperties]
  );

  return { syncProperties, syncActionTimestamp, syncActionCount };
};

